import { useRef } from 'react';

const defaultDebounceTimeout = 500;

const useDebounce = timeout => {
  const timeoutRef = useRef();
  const debounceTimeout = timeout ?? defaultDebounceTimeout;

  const debounce = callback => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(callback, debounceTimeout);
  };

  return [debounce];
};

export default useDebounce;
